"use client";

import { useCallback } from "react";
import { useSearchParams, usePathname, useRouter } from "next/navigation";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { type SortOrder } from "./list-therapists-search";

const sortOptions = [
  {
    value: "recommended",
    label: "Preporučeni",
  },
  {
    value: "price-asc",
    label: "Cena: najniža",
  },
  {
    value: "price-desc",
    label: "Cena: najviša",
  },
] as const;

export default function SortDropdown() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  const currentSort = (searchParams.get("sort") as SortOrder) ?? "recommended";
  const currentSortLabel =
    sortOptions.find((option) => option.value === currentSort)?.label ??
    "Preporučeni";

  const handleSort = useCallback(
    (value: string) => {
      const params = new URLSearchParams(searchParams.toString());
      if (value && value !== "recommended") {
        params.set("sort", value as SortOrder);
      } else {
        params.delete("sort");
      }

      const queryString = params.toString();
      const nextUrl = `${pathname}${queryString ? `?${queryString}` : ""}`;
      const currentUrl = `${pathname}${searchParams.toString() ? `?${searchParams.toString()}` : ""}`;

      if (nextUrl === currentUrl) return;

      router.push(nextUrl, {
        scroll: false,
      });
    },
    [router, searchParams, pathname],
  );

  return (
    <Select value={currentSort} onValueChange={handleSort}>
      <SelectTrigger className="w-[160px]">
        <SelectValue>{currentSortLabel}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {sortOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
